import { render } from "./AssStudentMaster.vue?vue&type=template&id=79c6aa35&scoped=true"
import script from "./AssStudentMaster.vue?vue&type=script&lang=js"
export * from "./AssStudentMaster.vue?vue&type=script&lang=js"

import "./AssStudentMaster.vue?vue&type=style&index=0&id=79c6aa35&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6aa35"]])

export default __exports__